import React, {Component} from 'react';
import './CreatePasswordComponent.less';
import {ButtonPrimary, ButtonLink} from '@homeaway/react-buttons';
import {apiPost} from '../../util/api.client';

class CreatePasswordComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailAddress: this.props.emailAddress
        };
        this.returnToResetPassword = this.returnToResetPassword.bind(this);
    }

    returnToResetPassword() {
        const url = '/auth/aam/v3/password/reset';
        const body = {
            'emailAddress': this.state.emailAddress,
            serviceUrl: this.props.service
        };

        apiPost(url, body).then(({status}) => {
            if (status === 204) {
                this.props.updatePage('passwordreset');
            } else {
                this.props.handleError(this.props.lingua.read('error.generic'), '');
            }
        });
    }

    render() {
        if (this.props.displayButton === true) {
            return (<div className="text-center">
                <ButtonPrimary className="Create-password-btn" label={this.props.lingua.read('lex.password.create.mu')} onClick={this.returnToResetPassword}/>
            </div>);
        }
        return (<div className="text-center">
            <ButtonLink className="Link" label={this.props.lingua.read('lex.password.create.option')} onClick={this.returnToResetPassword}/>
        </div>);
    }
}

export default CreatePasswordComponent;
